"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _NotificationList = _interopRequireDefault(require("ReduxMessenger/components/NotificationList"));

var _UIApplication = _interopRequireDefault(require("UIComponents/app/UIApplication"));

var AppContainer = _react.default.createClass({
  displayName: "AppContainer",
  propTypes: {
    children: _react.PropTypes.element.isRequired
  },
  render: function render() {
    return _react.default.createElement(_UIApplication.default, {
      className: "app-container",
      name: "MarketplaceUI"
    }, _react.default.createElement(_NotificationList.default, null), this.props.children);
  }
});

var _default = AppContainer;
exports.default = _default;
module.exports = exports.default;